import { useNavigate } from "react-router-dom";
import { Box, Tabs, Tab, Typography, Button, Paper, CardContent, Card, Divider, TableContainer, Table, TableBody, TableCell, TableRow, Chip, Grid } from "@mui/material";
import { Payment as PaymentIcon, Done as DoneIcon } from "@mui/icons-material";
import { FC, useContext, useEffect, useState } from "react";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";
import TabPanel from "../../../../../shared/components/tabpanel/tabpanel";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import { TitleBarProps } from "../../../../../shared/components/titleBar";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { LoadingButton } from "@mui/lab";
import { formatDateToDDMMYYYY } from "../../../../../shared/utils/dateFormat";

const StudentFeeSummary: FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { payload } = useContext(SidebarContext);
  const studentId = localStorage.getItem("selectedStudentId");
  const { loading, data } = useQuery(`/parent-students/${studentId}`, { params: payload });
  const studentData = (data as any)?.data;

  const studentClass = studentData?.studentClass?.[0];
  const feeTerms = studentClass?.class?.fee?.feeTerms || [];
  const feeStatus = studentData?.feePaymentStatus || {};
  const [paymentloading, setLoading] = useState<boolean>(false);

  const [receiptFlag, setReceiptFlage] = useState<boolean>(false);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => setActiveTab(newValue);
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const { loading: apiLoading, modifyData } = useMutation();

  const receiptClick = async (transactionID: string) => {
    setReceiptFlage(true);
    navigate(`/fee/payment-receipt/${transactionID}`);
  }

  const handlePayClick = async (term: { split: Record<string, number>; amount: number;[key: string]: any }) => {

    setLoading(true);
    const payload = {
      amount: term.split['Grand Total'],
      id: term.id,
      studentEmail: studentData.parent.email,
      studentPhone: studentData.parent.phone,
      studentName: studentData.parent.name,
      studentClassId: studentData.parent.id,
      feeTermID: term.id,
      studentClassID: studentData.studentClass[0].id,
    };

    const response = await modifyData(
      "/payment-gateway/initiate-payment",
      "post",
      payload
    );

    if (response?.data) {
      const easebuzz = new (window as any).EasebuzzCheckout(
        process.env.REACT_APP_EASYBUZZ_KEY,
        process.env.REACT_APP_EASYBUZZ_PAYMENT_MODE
      );
      easebuzz.initiatePayment({
        access_key: response.data,
        onResponse: async (res: any) => {

          const paymentPayload = {
            amount: parseInt(res.amount),
            feeTermID: term.id,
            paymentStatus: res.status,
            easeBuzzID: res.easepayid,
            studentClassID: studentData.studentClass[0].id,
            transactionID: res.txnid,
          };
          await modifyData(
            "/payment-gateway/payment",
            "post",
            { ...paymentPayload }
          );
          if (res.status === 'success') {
            window.location.href = "/payment/paymentSuccess";
          }
          else if (res.status === 'userCancelled') {
            setLoading(false);

            return;
          }
          else {
            window.location.href = "/payment/paymentFailure";
          }
          setLoading(false);
        },
        theme: "#666"
      });
    }

  };


  if (loading || !studentData) return <div>Loading...</div>;

  const titleBar: TitleBarProps = {
    title: "Fee Details",
    editCloseIcon: {
      visible: true,
      onClick: () => navigate(-1),
    },
  };
  return (
  <ProfileBorderBox>
    <ViewContainer
      titleBar={titleBar}
      tabs={
        <>
          <Card sx={{ p: 2, mb: 0.5, boxShadow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1">
                  Name: <strong>{studentData?.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1">
                  Class: <strong>{studentClass?.class?.displayName}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1">
                  Roll Number: <strong>{studentClass?.rollNumber}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1">
                  Parent Name: <strong>{studentData?.parent?.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" sx={{ mb: 1.5 }}>
                  Phone: <strong>{studentData?.parent?.phone}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Card>

          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 1 }}
          >
            {feeTerms.map((term: any) => (
              <Tab key={term.id} label={term.name} />
            ))}
          </Tabs>
        </>
      }
    >
      {feeTerms.length === 0 && (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          No fee terms found for this student.
        </Typography>
      )}

      {feeTerms.map((term: any, index: number) => {
        const isPaid = feeStatus[term.name] === true;
        const transaction = studentClass?.transactions?.find(
          (t: any) => t.feeTermID === term.id
        );
        return (
          <TabPanel key={term.id} value={activeTab} index={index}>
            <Card
              variant="outlined"
              sx={{ boxShadow: 3, mb: 2, backgroundColor: "#f0f3fa" }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {term.name}
                    {!isPaid && term.dueOn && (
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: "rgba(242, 8, 8, 0.87)", ml: 2 }}
                      >
                        (Due on: {formatDateToDDMMYYYY(term?.dueOn)})
                      </Typography>
                    )}
                  </Typography>
                  <Chip
                    label={isPaid ? "Paid" : "Unpaid"}
                    color={isPaid ? "success" : "warning"}
                    icon={isPaid ? <DoneIcon /> : <PaymentIcon />}
                    variant="outlined"
                  />
                </Box>

                <Divider sx={{ my: 1 }} />
                <Typography variant="subtitle1" gutterBottom>
                  Fee Breakdown
                </Typography>
                <TableContainer component={Paper} elevation={0}>
                  <Table size="small">
                    <TableBody>
                      {Object.entries(term.split)
                        .filter(([key]) => key !== "Total" && key !== "Grand Total")
                        .reverse()
                        .map(([key, value]) => (
                          <TableRow key={key}>
                            <TableCell>
                              {key === "Grand Total" || key === "Total" ? (
                                <strong>{key}</strong>
                              ) : (
                                key
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {key === "Grand Total" || key === "Total" ? (
                                <strong>₹{Number(value).toLocaleString()}</strong>
                              ) : (
                                `₹${Number(value).toLocaleString()}`
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      <TableRow>
                        <TableCell>
                          <strong>Overall Grand Total</strong>
                        </TableCell>
                        <TableCell align="right">
                          <strong>
                            ₹{term.split["Grand Total"].toLocaleString()}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {!isPaid ? (
                  <LoadingButton
                    loading={paymentloading}
                    id="ebz-checkout-btn"
                    variant="contained"
                    color="primary"
                    fullWidth
                    aria-label="Click here to get OTP"
                    onClick={() => handlePayClick(term)}
                    sx={{ mt: 3 }}
                    startIcon={<PaymentIcon />}
                  >
                    Pay Now ₹{term.split["Grand Total"].toLocaleString()}
                  </LoadingButton>
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                    <LoadingButton
                      loading={paymentloading}
                      id="ebz-checkout-btn"
                      variant="contained"
                      color="primary"
                      aria-label="Receipt"
                      onClick={() =>
                        receiptClick(transaction.paymentGatewayTransactionID)
                      }
                    >
                      Receipt
                    </LoadingButton>
                  </Box>
                )}
              </CardContent>
            </Card>
          </TabPanel>
        );
      })}
    </ViewContainer>
  </ProfileBorderBox>
);
}

export default StudentFeeSummary;